import React, {useEffect, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import {initialValuesClient, listRecentClients} from '../core/_models'
import {recentClient} from '../core/_request'
import Avatar from 'react-avatar'
import {Link, useNavigate} from 'react-router-dom'
import {useAuth} from '../../modules/auth'
import {getCRUD} from '../../modules/apps/companies/company-list/core/_requests'

type Props = {
  className: string
}

const ClientTable: React.FC<Props> = ({className}) => {
  const navigate = useNavigate()
  //settings
  const [data, setData] = useState<listRecentClients>(initialValuesClient)
  const [clients, setClients] = useState<any>([])
  const updateData = (fieldsToUpdate: Partial<listRecentClients>): void => {
    const updatedData = Object.assign(data, fieldsToUpdate)
    setData(updatedData)
  }

  useEffect(() => {
    recentClient().then((res: any) => {
      setClients(res.data.data)
     
    })
  }, [])
  const viewCompanyDetails = (Id: any) => {
    navigate('/companies/view/' + Id)
  }
  const {currentUser} = useAuth()
  const [clientaccess, setclientaccess] = useState<any>([])

  useEffect(() => {
    getCRUD(currentUser?.role, 10).then((res: any) => {
      var crudres = res.data?.Data[0]
      setclientaccess(crudres)
    })
  }, [])

  //settings
  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Recent Agencys</span>
          <span className='text-muted mt-1 fw-semibold fs-7'>List of recently created Agencys</span>
        </h3>
        <div
          className='card-toolbar'
          data-bs-toggle='tooltip'
          data-bs-placement='top'
          data-bs-trigger='hover'
          title='Click to view all data'
        >
          {clientaccess?.list === 1 ? (
            <Link
              to='/companies/list'
              className='btn btn-sm text-white'
              style={{background: '#9E2A8D'}}
              // data-bs-toggle='modal'
              // data-bs-target='#kt_modal_invite_friends'
            >
              <KTSVG path='media/icons/duotune/files/fil001.svg' className='svg-icon-3 text-white' />
              View All
            </Link>
          ) : (
            ''
          )}
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body py-3'>
        {/* begin::Table container */}
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bold text-muted'>
                <th className='min-w-150px'>Agency Name</th>
                <th className='min-w-150px'>Contact</th>
                <th className='min-w-150px'>POC Contact</th>

                <th className='min-w-120px'>Country</th>
                <th className='min-w-120px'>State</th>
                {clientaccess?.view === 1 ? <th className='min-w-100px text-end'>Actions</th> : ''}
              </tr>
            </thead>
            {/* end::Table head */}
            {/* begin::Table body */}

            <tbody>
              {clients?.map((item: any, i: any) => {
                return (
                  <tr key={i}>
                    <td>
                      <div className='d-flex align-items-center'>
                        <div className='symbol symbol-45px me-5'>
                          <Avatar size='40' round='20px' name={item?.name} maxInitials={2} />
                        </div>
                        <div className='d-flex justify-content-start flex-column'>
                          <a  className='text-dark fw-bold  fs-6'>
                            {item?.name.slice(0, 20)}
                            {item?.name.length > 20 && '...'}
                          </a>
                          <span className='text-muted fw-semibold text-muted d-block fs-7'>
                            Clinic
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>
                      {item?.email.slice(0, 15)}
                      {item?.email.length > 15 && '...'}
                      <br></br> {item?.telephoneNumber}
                    </td>
                    <td>
                      {item?.primaryEmail.slice(0, 15)}
                      {item?.primaryEmail.length > 15 && '...'}
                      <br></br> {item?.primaryTelephone}
                    </td>

                    <td>{item?.country}</td>
                    <td>
                      {item?.state}
                      <span className='text-muted fw-semibold text-muted d-block fs-7'>
                        {item?.pincode}
                      </span>
                    </td>
                    {clientaccess?.view === 1 ? (
                      <td>
                        <div className='d-flex justify-content-end flex-shrink-0'>
                          <a
                            onClick={() => viewCompanyDetails(item?.id)}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          >
                            <KTSVG
                              path='/media/icons/duotune/general/eye.svg'
                              className='svg-icon-3'
                            />
                          </a>

                          {/* <a
                      
                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                    >
                      <KTSVG
                        path='/media/icons/duotune/general/gen027.svg'
                        className='svg-icon-3'
                      />
                    </a> */}
                        </div>
                      </td>
                    ) : (
                      ''
                    )}
                  </tr>
                )
              })}
            </tbody>
            {/* end::Table body */}
          </table>
          {/* end::Table */}
        </div>
        {/* end::Table container */}
      </div>
      {/* begin::Body */}
    </div>
  )
}

export {ClientTable}
